import { NbMenuItem } from '@nebular/theme';

export const MENU_ITEMS: NbMenuItem[] = [
  {
    title: 'Dashboard',
    icon: 'shopping-cart-outline',
    link: '/pages/dashboard',
    home: true,
  },
  // {
  //   title: 'Graph Dashboard',
  //   icon: 'home-outline',
  //   link: '/pages/graph',
  // },
  {
    title: 'FEATURES',
    group: true,
  },
  {
  title: 'Schools',
  icon: 'book-outline',
  link: '/pages/schools',
},
  {
    title: 'Tutor',
    icon: 'people-outline',
    link: '/pages/tutor',
  },
  {
    title: 'Students',
    icon: 'credit-card-outline',
    link: '/pages/students',
  },
  {
    title: 'Q&A',
    icon: 'shopping-bag-outline',
    link: '/pages/qna',
  },
  {
    title: 'Subjects',
    icon: 'shopping-bag-outline',
    link: '/pages/subjects',
  },
  {
  title: 'Request Rights',
  icon: 'clipboard-outline',  
  link: '/pages/request-rights',
},
{
  title: 'Coupons',
  icon: 'pricetags-outline',   
  link: '/pages/coupons',
},
{
  title: 'Subscription Plan',
  icon: 'credit-card-outline',  
  link: '/pages/subscription-plan',
},

{
  title: 'Storage',
  icon: 'folder-outline',  
  link: '/pages/storage',
},

  // {
  //   title: 'Products',
  //   icon: 'cube-outline',
  //   link: '/pages/products',
  // },
  // {
  //   title: 'Top Picks',
  //   icon: 'star-outline',
  //   link: '/pages/products/top-picks',
  // },
  // {
  //   title: 'Order',
  //   icon: 'clock-outline',
  //   link: '/pages/pending-order',
  // },
  // {
  //   title: 'Spotlight',
  //   icon: 'clock-outline',
  //   link: '/pages/products/spotlight',
  // },
  // {
  //   title: 'Reviews',
  //   icon: 'message-square-outline',
  //   link: '/pages/review',
  // },
  {
    title: 'Setting',
    icon: 'settings-2-outline',
    link: '/pages/setting',
  },
  {
    title: 'Notifications',
    icon: 'bell',
    link: '/pages/notification',
  },
  {
    title: 'Support',
    icon: 'message-circle-outline',
    link: '/pages/support',
  },
  {
  title: 'Access Control',
  icon: 'lock-outline',
  link: '/pages/access-control',
}
,
    {
    title: 'Logout Requests',
    icon: 'log-out-outline',
    link: '/pages/logout-requests',
  },


  // {
  //   title: 'Layout',
  //   icon: 'layout-outline',
  //   children: [
  //     {
  //       title: 'Stepper',
  //       link: '/pages/layout/stepper',
  //     },
  //     {
  //       title: 'List',
  //       link: '/pages/layout/list',
  //     },
  //     {
  //       title: 'Infinite List',
  //       link: '/pages/layout/infinite-list',
  //     },
  //     {
  //       title: 'Accordion',
  //       link: '/pages/layout/accordion',
  //     },
  //     {
  //       title: 'Tabs',
  //       pathMatch: 'prefix',
  //       link: '/pages/layout/tabs',
  //     },
  //   ],
  // },
  // {
  //   title: 'Forms',
  //   icon: 'edit-2-outline',
  //   children: [
  //     {
  //       title: 'Form Inputs',
  //       link: '/pages/forms/inputs',
  //     },
  //     {
  //       title: 'Form Layouts',
  //       link: '/pages/forms/layouts',
  //     },
  //     {
  //       title: 'Buttons',
  //       link: '/pages/forms/buttons',
  //     },
  //     {
  //       title: 'Datepicker',
  //       link: '/pages/forms/datepicker',
  //     },
  //   ],
  // },
  // {
  //   title: 'UI Features',
  //   icon: 'keypad-outline',
  //   link: '/pages/ui-features',
  //   children: [
  //     {
  //       title: 'Grid',
  //       link: '/pages/ui-features/grid',
  //     },
  //     {
  //       title: 'Icons',
  //       link: '/pages/ui-features/icons',
  //     },
  //     {
  //       title: 'Typography',
  //       link: '/pages/ui-features/typography',
  //     },
  //     {
  //       title: 'Animated Searches',
  //       link: '/pages/ui-features/search-fields',
  //     },
  //   ],
  // },
  // {
  //   title: 'Modal & Overlays',
  //   icon: 'browser-outline',
  //   children: [
  //     {
  //       title: 'Dialog',
  //       link: '/pages/modal-overlays/dialog',
  //     },
  //     {
  //       title: 'Window',
  //       link: '/pages/modal-overlays/window',
  //     },
  //     {
  //       title: 'Popover',
  //       link: '/pages/modal-overlays/popover',
  //     },
  //     {
  //       title: 'Toastr',
  //       link: '/pages/modal-overlays/toastr',
  //     },
  //     {
  //       title: 'Tooltip',
  //       link: '/pages/modal-overlays/tooltip',
  //     },
  //   ],
  // },
  // {
  //   title: 'Extra Components',
  //   icon: 'message-circle-outline',
  //   children: [
  //     {
  //       title: 'Calendar',
  //       link: '/pages/extra-components/calendar',
  //     },
  //     {
  //       title: 'Progress Bar',
  //       link: '/pages/extra-components/progress-bar',
  //     },
  //     {
  //       title: 'Spinner',
  //       link: '/pages/extra-components/spinner',
  //     },
  //     {
  //       title: 'Alert',
  //       link: '/pages/extra-components/alert',
  //     },
  //     {
  //       title: 'Calendar Kit',
  //       link: '/pages/extra-components/calendar-kit',
  //     },
  //     {
  //       title: 'Chat',
  //       link: '/pages/extra-components/chat',
  //     },
  //   ],
  // },
  // {
  //   title: 'Maps',
  //   icon: 'map-outline',
  //   children: [
  //     {
  //       title: 'Google Maps',
  //       link: '/pages/maps/gmaps',
  //     },
  //     {
  //       title: 'Leaflet Maps',
  //       link: '/pages/maps/leaflet',
  //     },
  //     {
  //       title: 'Bubble Maps',
  //       link: '/pages/maps/bubble',
  //     },
  //     {
  //       title: 'Search Maps',
  //       link: '/pages/maps/searchmap',
  //     },
  //   ],
  // },
  // {
  //   title: 'Charts',
  //   icon: 'pie-chart-outline',
  //   children: [
  //     {
  //       title: 'Echarts',
  //       link: '/pages/charts/echarts',
  //     },
  //     {
  //       title: 'Charts.js',
  //       link: '/pages/charts/chartjs',
  //     },
  //     {
  //       title: 'D3',
  //       link: '/pages/charts/d3',
  //     },
  //   ],
  // },
  // {
  //   title: 'Editors',
  //   icon: 'text-outline',
  //   children: [
  //     {
  //       title: 'TinyMCE',
  //       link: '/pages/editors/tinymce',
  //     },
  //     {
  //       title: 'CKEditor',
  //       link: '/pages/editors/ckeditor',
  //     },
  //   ],
  // },
  // {
  //   title: 'Tables & Data',
  //   icon: 'grid-outline',
  //   children: [
  //     {
  //       title: 'Smart Table',
  //       link: '/pages/tables/smart-table',
  //     },
  //     {
  //       title: 'Tree Grid',
  //       link: '/pages/tables/tree-grid',
  //     },
  //   ],
  // },
  // {
  //   title: 'Auth',
  //   icon: 'lock-outline',
  //   children: [
  //     {
  //       title: 'Change Password',
  //       link: '/auth/change-password',
  //     },
  //   ],
  // },
  // {
  //   title: 'Log Out',
  //   icon: 'lock-outline',
  //   link: '/auth/logout',
  // },
];
